import {createContext} from 'react';

const UIPopupContext = createContext({});

export const uiPopupContextReducer = (state = {}, action) => {
  return {...state, ...action};
}

export default UIPopupContext;
